import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface AgentV2UpdateTemplateResponse {
  message: string;
  agent_id: string;
  user_id: number;
  is_agent: number;
}

export interface AgentV2UpdateTemplateRequest {
  uuid: string;
  styleId?: string;
  actorModelId?: string;
  voiceModelId?: string;
  speedRatio?: number;
  agentId: string;
  userId: string;
  templateName?: string;
  coverUrl?: string; // 风格封面
  coverVideo?: string; // 风格视频
  type: number;
}

export class AgentV2UpdateTemplateData {
  id?: number;
}

const transformAndValidateData = (
  response: AgentV2UpdateTemplateResponse
): AgentV2UpdateTemplateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2UpdateTemplateData);
  } catch (error) {
    console.error("AgentV2UpdateTemplate data validation failed:", error.message);
    throw error;
  }
};

// 更新智能体模板
export const agentV2UpdateTemplate = async ({
  uuid,
  agentId,
  userId,
  styleId,
  coverVideo,
  coverUrl,
  type,
  templateName,
  actorModelId,
  voiceModelId,
  speedRatio,
}: AgentV2UpdateTemplateRequest) => {
  const res = await api.post<AgentV2UpdateTemplateResponse>('/agent-v2/update-template', {
    uuid,
    agent_id: agentId,
    user_id: userId,
    style_id: styleId,
    cover_video: coverVideo,
    cover_url: coverUrl,
    type: type,
    template_name: templateName,
    actor_model_id: actorModelId,
    voice_model_id: voiceModelId,
    speed_ratio: speedRatio,
  });
  return transformAndValidateData(res.data);
};
